import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'

export const HeaderEntityWithCompanyStyled = styled(Typography, {
  name: 'HeaderEntityWithCompany',
})(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '28px',
  fontFamily: 'Source Sans Pro Bold',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  [theme.breakpoints.down('lg')]: {
    maxWidth: '65vw',
  },
  [theme.breakpoints.up('lg')]: {
    maxWidth: '38vw',
  },

  span: {
    textTransform: 'uppercase',
  },
}))
